var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-721 -413)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(721 413)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sandclock",
    transform: "translate(729.6 423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M17.929,7.795a.7.7,0,0,0,.433-.15,10.85,10.85,0,0,0,1.632-1.5.7.7,0,1,0-1.079-.892,9.846,9.846,0,0,1-1.42,1.3.7.7,0,0,0,.434,1.249Z",
    transform: "translate(-3.969 -1.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M4,21.3a.7.7,0,0,0,.7.7H20.1a.7.7,0,1,0,0-1.4H18.915a3.578,3.578,0,0,0,.485-1.82c0-2.535-2.3-4.074-4.143-5.311C14.246,12.792,13.1,12.024,13.1,11.5c0-.549,1.161-1.429,2.186-2.2C17.119,7.907,19.4,6.18,19.4,3.66a3.655,3.655,0,0,0-.219-1.26H20.1a.7.7,0,1,0,0-1.4H4.7a.7.7,0,0,0,0,1.4h.919A3.655,3.655,0,0,0,5.4,3.66C5.4,6.18,7.681,7.907,9.514,9.3c1.025.776,2.186,1.655,2.186,2.2,0,.524-1.146,1.292-2.157,1.969C7.7,14.706,5.4,16.245,5.4,18.78a3.578,3.578,0,0,0,.485,1.82H4.7A.7.7,0,0,0,4,21.3ZM10.359,8.179C8.69,6.916,6.8,5.48,6.8,3.66A2.19,2.19,0,0,1,7.184,2.4h10.43A2.19,2.19,0,0,1,18,3.66c0,1.82-1.89,3.256-3.559,4.519A13.887,13.887,0,0,0,12.4,9.933a13.887,13.887,0,0,0-2.04-1.753ZM6.8,18.78c0-1.787,1.871-3.041,3.522-4.148A12.134,12.134,0,0,0,12.4,13.024a12.134,12.134,0,0,0,2.078,1.61C16.129,15.739,18,16.993,18,18.78a2.408,2.408,0,0,1-.874,1.82H7.674A2.408,2.408,0,0,1,6.8,18.78Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPending);
export default __webpack_public_path__ + "static/media/icon-pending.edfc789e42fc596c7a7783bc4a9844a1.svg";
export { ForwardRef as ReactComponent };